<template>
  <div class="bg-white flex flex-col justify-between mt-10 h-full">
    <section :aria-label="$t('product.widget')" class="max-h-full">
      <button @click="openProductView" v-if="product">
        <img :src="selectedProduct.cover" :alt="getAltText(selectedProduct.description)"
          class="transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-105">
      </button>
      <Skeleton :loading="!product" height="12.5vw" class="hidden lg:block" />
      <Skeleton :loading="!product" height="25vw" class="lg:hidden hidden md:block" />
      <Skeleton :loading="!product" height="40vw" class="md:hidden" />
      <div :class="product ? '' : 'py-2'">
        <Skeleton :loading="!product" lineHeight="1.5"/>
      </div>
      <div :class="product ? '' : 'w-1/3 pt-1'">
        <Skeleton :loading="!product" lineHeight="1.5" />
      </div>
      <div :class="product ? '' : 'pt-6'">
        <Skeleton :loading="!product" lineHeight="2"/>
      </div>

      <div class="w-full flex justify-between text-xs md:text-sm font-bold mt-2 h-14 md:h-20 lg:h-14" v-if="product">
        <h2 class="pr-2" >
          {{ selectedProduct['description_'+$i18n.locale] ? selectedProduct['description_'+$i18n.locale] : selectedProduct.description }}
        </h2>

        <div class="text-right hidden">
          <h3 class="font-sans-serif">
            {{ formatter.format(priceToShow / 100) }}
          </h3>
          <h4 class="text-b2c-red-300 italic" v-if="selectedProduct.is_discounted && selectedProduct.discount_rate"
            @mouseover="setShowWhyDiscount($event)" @mouseout="setShowWhyDiscount($event)">
            -{{ selectedProduct.discount_rate }}%
          </h4>
        </div>
      </div>
      <div class="text-left pb-5 pt-2" v-if="product">
        <h3 class="font-sans-serif">
          {{ formatter.format(priceToShow / 100) }}
        </h3>
        <h4 class="text-b2c-red-300 italic w-1/4" v-if="selectedProduct.is_discounted && selectedProduct.discount_rate"
          @mouseover="setShowWhyDiscount($event)" @mouseout="setShowWhyDiscount($event)">
          -{{ selectedProduct.discount_rate }}%
        </h4>
      </div>
    </section>
    <div class="flex flex-col justify-start mt-1" v-if="product">
      <button v-if="!selectedProduct.out_of_stock"
        class="border border-gray-500 px-4 py-1 rounded hover:bg-redish hover:text-white text-sm lg:text-base"
        @click="addToCart"
      >
        {{$t('product.addToCart')}}
      </button>
      <div v-else>
        <span v-if="!selectedProduct.available_on_request" class="italic text-b2c-red-300 pb-2">
          {{ $t('product.outOfStock') }}
        </span>
        <on-request-button v-else :product="selectedProduct" class="w-full" />
      </div>

    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { addProductToCart } from '@/services/ProductService';
import { Skeleton } from '@/components/Skeleton/src/index';
import OnRequestButton from './OnRequestButton.vue';

export default {
  props: {
    product: Object,
  },

  data() {
    return {
      selectedProduct: {},
      quantity: 1,

      reload: false,
    };
  },

  components: {
    Skeleton,
    OnRequestButton,
  },

  mounted() {
    if (this.product) this.selectedProduct = this.product;
  },

  watch: {
    product() {
      this.selectedProduct = this.product;
    },
  },

  computed: {
    ...mapGetters({
      changedLocale: 'auth/changedLocale',
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      isTaxable: 'auth/isTaxable',
    }),

    priceWithVat() {
      return (this.product.price * this.vat_rate) / 100;
    },
    vat_rate() {
      return 100 + this.selectedProduct.vat_rate;
    },

    priceToShow() {
      if (!this.isTaxable) {
        return this.selectedProduct.price;
      }
      return this.priceWithVat;
    },
  },

  methods: {
    ...mapActions({
      showWhyDiscount: 'notification/showWhyDiscount',
    }),

    getAltText(productDescription) {
      return `${this.$t('product.alt')} ${productDescription}`;
    },

    addToCart() {
      addProductToCart(this.product, this.quantity);
      this.createNotification('success', this.$t('product.addedToCart'));
    },

    openProductView() {
      this.$router.push({ path: `/products/${this.selectedProduct.sku}` }).catch(() => {});
    },

    setShowWhyDiscount(mouseEvent) {
      this.showWhyDiscount();
      this.$store.dispatch('notification/setMouseXPosition', mouseEvent.clientX);
      this.$store.dispatch('notification/setMouseYPosition', mouseEvent.clientY);
    },
  },
};
</script>
